// Custom.js

/**
 * First-load Okendo FOUC fix.
 *
 * custom.css hides [data-oke-reviews-widget-holder] and [data-oke-widget]
 * with visibility:hidden until we set data-oke-ready on them. This prevents
 * the flash of unstyled Okendo markup that appears on cold loads before
 * Okendo's dynamically-injected <link rel="stylesheet"> has arrived.
 *
 * On reload the CSS is cached and the widget initializes fast enough that
 * the flash doesn't appear — which is exactly why it "fixes itself on reload".
 */
(function () {
  function revealOkeContainers() {
    document.querySelectorAll(
      '[data-oke-reviews-widget-holder], [data-oke-widget]'
    ).forEach(function (el) {
      el.setAttribute('data-oke-ready', '');
    });
  }

  function waitForOkeCssAndReveal() {
    var okeLinks = Array.from(document.querySelectorAll('link[rel="stylesheet"]'))
      .filter(function (l) { return l.href && l.href.includes('okendo'); });

    if (okeLinks.length === 0 || okeLinks.every(function (l) { return l.sheet; })) {
      revealOkeContainers();
      return;
    }

    var pending = okeLinks.filter(function (l) { return !l.sheet; });
    var done = 0;
    function onDone() {
      if (++done >= pending.length) revealOkeContainers();
    }
    pending.forEach(function (l) {
      l.addEventListener('load', onDone, { once: true });
      l.addEventListener('error', onDone, { once: true });
    });
  }

  // Watch for Okendo to inject its widget HTML (adds .oke-w to the containers).
  var observer = new MutationObserver(function () {
    if (document.querySelector('.oke-w')) {
      observer.disconnect();
      waitForOkeCssAndReveal();
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  // Hard fallback: if Okendo never initializes (e.g. page has no widget),
  // reveal after 3s so the hidden min-height placeholder doesn't linger.
  setTimeout(function () {
    observer.disconnect();
    revealOkeContainers();
  }, 3000);
})();

/**
 * Re-initialize Okendo widgets after Barba page transitions.
 *
 * The theme's afterEnter hook calls okeWidgetApi.initAllWidgets() at t=0,
 * but app blocks are replaced at ~t=60ms (wiping out the t=0 render).
 *
 * Rather than fixed timeouts (which lose the race on slow connections),
 * we use a MutationObserver to detect when the fresh Okendo widget container
 * lands in the DOM after the app block swap, then call initAllWidgets once
 * the CSS link for Okendo has actually loaded.
 */
document.addEventListener('pageFullyLoaded', function () {
  if (typeof window?.okeWidgetApi?.initAllWidgets !== 'function') return;

  var contentRoot = document.querySelector('[data-content-root]') || document.body;
  var settled = false;

  function safeInit() {
    if (settled) return;
    settled = true;
    obs.disconnect();

    // Wait for any pending Okendo <link> stylesheets to finish loading
    var okeLinks = Array.from(document.querySelectorAll('link[rel="stylesheet"]'))
      .filter(function (l) { return l.href && l.href.includes('okendo'); });

    if (okeLinks.length === 0 || okeLinks.every(function (l) { return l.sheet; })) {
      // CSS already loaded (or no oke CSS found) — init immediately
      window.okeWidgetApi.initAllWidgets();
    } else {
      // Wait for the last Okendo stylesheet to load before mounting
      var pending = okeLinks.filter(function (l) { return !l.sheet; });
      var done = 0;
      pending.forEach(function (l) {
        l.addEventListener('load', function () {
          if (++done >= pending.length) window?.okeWidgetApi?.initAllWidgets?.();
        }, { once: true });
        l.addEventListener('error', function () {
          if (++done >= pending.length) window?.okeWidgetApi?.initAllWidgets?.();
        }, { once: true });
      });
      // Hard fallback: if stylesheets take >2s something else is wrong
      setTimeout(function () { window?.okeWidgetApi?.initAllWidgets?.(); }, 2000);
    }
  }

  // Watch for Okendo's widget container to appear after the ~60ms app block swap
  var obs = new MutationObserver(function () {
    if (document.querySelector('[data-oke-reviews-widget-holder], [data-oke-widget], .oke-w')) {
      safeInit();
    }
  });
  obs.observe(contentRoot, { childList: true, subtree: true });

  // Fallback: if MutationObserver never fires (no oke widget on this page),
  // disconnect after 3s and do nothing
  setTimeout(function () {
    if (!settled) { settled = true; obs.disconnect(); }
  }, 3000);
});

/**
 * Force full-page reloads for paths where third-party app widgets
 * (e.g. Okendo Rewards) need fresh initialization that Barba's
 * client-side transitions don't provide.
 *
 * Mirrors the pattern already used in page-transitions.ts for
 * /pages/store-locator and /pages/customer-feedback.
 */
(function () {
  const FULL_RELOAD_PATHS = ['/pages/rewards'];

  function requiresFullReload(href) {
    try {
      const url = new URL(href, window.location.origin);
      return (
        url.origin === window.location.origin &&
        FULL_RELOAD_PATHS.includes(url.pathname) &&
        url.pathname !== window.location.pathname
      );
    } catch (e) {
      return false;
    }
  }

  // Intercept link clicks in capture phase — fires before Barba's listener.
  document.addEventListener(
    'click',
    function (e) {
      const link = e.target.closest('a[href]');
      if (link && requiresFullReload(link.href)) {
        e.stopImmediatePropagation();
        window.location.href = link.href;
      }
    },
    true
  );

  // Patch barba.go once available to cover programmatic navigation.
  var _patchBarbaGoAttempts = 0;
  function patchBarbaGo() {
    if (typeof window.barba !== 'undefined' && typeof window.barba.go === 'function') {
      const originalGo = window.barba.go.bind(window.barba);
      window.barba.go = function (href, trigger, options) {
        if (requiresFullReload(href)) {
          window.location.href = href;
          return Promise.resolve();
        }
        return originalGo(href, trigger, options);
      };
    } else if (_patchBarbaGoAttempts++ < 50) {
      // Retry for up to 5 seconds (50 × 100ms). If Barba never loads,
      // navigation falls back to the browser's default behaviour anyway.
      setTimeout(patchBarbaGo, 100);
    }
  }
  patchBarbaGo();
})();
